import React from "react";
import { FirefoxDateFilterHeaderCell } from "../components/FirefoxDateFilterHeaderCell";
import { IsFirefoxUser } from "shared/helpers/BrowserDetectionHelpers";

//NOTE: This logic and the associated FirefoxDateFilterHeaderCell components only needs to be here
//until Telerik fixes the Firefox date issue related to the scrolling on their Calendar component
export function CreateEnhancedChildrenForFirefox(children) {
  if (!IsFirefoxUser()) return children;

  return React.Children.map(children, (child) => {
    if (child && child.props && child.props.filter === "date") {
      return React.cloneElement(child, {
        cells: { ...child.props.cells, filterCell: FirefoxDateFilterHeaderCell },
      });
    }
    return child;
  });
}
